import { createFileRoute } from '@tanstack/react-router';
import { LocationPage } from '@/features/locations/LocationPage';
import { validateDrawerSearch } from '@/features/locations/search';

export const Route = createFileRoute('/app/board/$locationId/')({
  validateSearch: validateDrawerSearch,
  component: LocationRoute,
  staticData: { title: 'Site' },
});

function LocationRoute() {
  const { locationId } = Route.useParams();
  const drawers = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LocationPage
      key={locationId}
      locationId={locationId}
      drawers={drawers}
      onDrawersChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
}
